import { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { useAuth } from "@/context/AuthContext";

// Handles the Emergent Google Auth return: {redirect_url}#session_id=...
export const AuthCallback = () => {
  const navigate = useNavigate();
  const { exchangeSession } = useAuth();
  const hasProcessed = useRef(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;
    const hash = window.location.hash || "";
    const params = new URLSearchParams(hash.replace(/^#/, ""));
    const sessionId = params.get("session_id");
    const run = async () => {
      try {
        const user = await exchangeSession(sessionId);
        window.history.replaceState(null, "", window.location.pathname);
        navigate("/dashboard", { replace: true, state: { user } });
      } catch (e) {
        setError("Accesso con Google non riuscito. Riprova.");
        window.history.replaceState(null, "", window.location.pathname);
        setTimeout(() => navigate("/login", { replace: true }), 1500);
      }
    };
    run();
  }, [exchangeSession, navigate]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-background" data-testid="auth-callback-screen">
      <div className="flex flex-col items-center gap-3 text-muted-foreground">
        {error ? <p className="text-destructive">{error}</p> : <Loader2 className="h-6 w-6 animate-spin" />}
        {!error && <p className="text-sm">Completamento accesso…</p>}
      </div>
    </div>
  );
};
